<template>
    <section class="questionwrapper">
      <div class="helper-holder">
      <!--<img alt="Vue logo" src="../assets/vue-logo-svg.svg">-->
      <p>Thank you for your interest! <br>
      <span class="smalltext">In the meantime, check out our work at <a href="https://redonion.se/" title="Visit redonion.se" style="color:#d21fba;">redonion.se</a>.</span></p>
      <!--<p class="mediumtext">{{ message }}</p>-->
      <p class="mediumtext" v-html="message"></p>
      </div>
    </section>
</template>

<script>
export default {
  data: function () {
    return {
      message: 'We’ll be in touch... maybe'
    };
  },
  props: {
    answerFiveC: {
      type: String
    }
  },
  methods: {
    showMessage: function () {
      // console.log('showmessage');
      if (this.answerFiveC === 'backpacking') {
        // this.message = 'We’re concerned how well you’ll fit into our culture.';
        this.message = '<em>We have several outsourced teams if you enjoy travelling</em> 🌍.';
        return this.message;
      } else if (this.answerFiveC === 'throne') {
        this.message = '👑 <em>Amibition is good, but we need to make sure it’s a good cultural fit.</em>';
        return this.message;
      } else if (this.answerFiveC === 'job') {
        this.message = '<em>Off the record, you are our strongest candidate this far!</em>';
        return this.message;
      } else if (this.answerFiveC === 'island') {
        this.message = '<em>Perhaps we need to go over salary expectations.</em>';
        return this.message;
      } else {
        this.message = '<em>We’ll be in touch... maybe</em>';
        return this.message;
      }
    }
  },
  created: function () {
    this.showMessage();
  }

};
</script>

<style>

</style>
